import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { BladeMark } from "@/components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const res = await api.post("/auth/login", { email, password });
      if (res.data?.token) localStorage.setItem("bamf_admin_token", res.data.token);
      nav("/admin");
    } catch (e2) {
      setErr(errorText(e2));
    } finally {
      setBusy(false);
    }
  };

  const input = "h-12 w-full border border-white/15 bg-transparent px-4 text-white focus:border-[var(--volt)] focus:outline-none";
  return (
    <main data-testid="admin-login-page" className="grid min-h-screen place-items-center bg-obsidian px-5">
      <form onSubmit={submit} className="w-full max-w-sm border border-white/10 bg-surface p-8">
        <BladeMark className="h-12 w-12" />
        <h1 className="mt-6 font-display text-4xl font-black uppercase">Admin Access</h1>
        <p className="mb-6 font-mono text-xs uppercase tracking-widest text-zinc-400">Authorized crew only</p>
        <div className="space-y-3">
          <input data-testid="admin-email-input" type="email" required placeholder="Email" className={input} value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="admin-password-input" type="password" required placeholder="Password" className={input} value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {err && <p data-testid="admin-login-error" className="mt-3 text-sm text-rescue">{err}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="btn-volt mt-6 h-12 w-full font-mono text-sm font-bold uppercase tracking-widest">
          <span className="flex items-center justify-center gap-2">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Sign In</span>
        </button>
      </form>
    </main>
  );
}
